const getters = {
    GET_LOADING_TRANSACTION_STATUS: (state) => state.loading_transaction_status,
    GET_TRANSACTION_DETAILS: (state) => state.transaction_details,
}


export default getters